/** Standard label for dropdown/picker fields that represent "no selection" */
export const DEFAULT_OPTION_LABEL = '– no selection –';
